import React from 'react'

const OfficesExplain = () => (
  <div>Les comptes office vous permettent d'afficher le planning de vos salariés sur des ordinateurs publiques.</div>
)

export default OfficesExplain
